import {api} from '../../lib/api'
import {get_message as $m} from '../../lib/messages'
import {notify, okcancel} from '../../lib/notifications'
import {dqs, error_handler, get_bugsnag} from '../../lib/util'
import {loading} from '../../lib/ui'

const process_update = async (amount, regular_donation) => {
  const bugsnag = get_bugsnag()
  const {customer_id, period, subscription_id: current_subscription_id} = regular_donation

  loading('show', $m('REGULAR_DONATION_UPDATING'))

  try {
    const {status, data} = await api.patch(`/donations`, {
      amount, current_subscription_id, customer_id, period,
      url: 'https://members.actionstation.org.nz' // KEEP THIS FOR STRIPE'S METADATA
    })

    if(status !== 200) {
      bugsnag.leaveBreadcrumb(`
        current_subscription_id = ${current_subscription_id}
        customer_id = ${customer_id}
        amount = ${amount}
        period = ${period}
      `)

      throw new Error(`status = ${status}, PATCH /members/donations`)
    }

    notify($m('REGULAR_DONATION_UPDATED'), 'success', () => {
      loading('show', $m('ACCOUNT_RELOADING'))
      setTimeout(() => window.location.reload(), 1000)

      return false
    })
  }
  catch(error) {
    error_handler(error)
  }
}

export const update_donation = async (email, regular_donation) => {
  const bugsnag = get_bugsnag()
  const {customer_id, period, subscription_id} = regular_donation

  bugsnag.leaveBreadcrumb(`increase donation | ${email}`)

  const {first_name} = JSON.parse(sessionStorage.user)
  const selected_button = dqs('form#update_donation button.update[data-selected="true"]')

  if(!selected_button) {
    return notify($m('ERROR_SELECT_INCREASE'), 'danger')
  }

  const new_amount = parseInt(selected_button.dataset.amount.trim(), 10)

  const question = $m('REGULAR_DONATION_UPDATE_CONFIRM', first_name, period, new_amount)
  okcancel(question, () => {
    process_update(new_amount, regular_donation)

    return false
  })
}
